import { Search } from "components/individual/Search";
import React, { useContext } from "react";
import { Label } from "structure/Document";
import { ContextCatalogueAdmin } from "..";

export default function SearchBar() {
  const hook = useContext(ContextCatalogueAdmin);

  return (
    <div>
      <Label>Descripción</Label>
      <Search
        placeholder="Escribe aquí"
        onChange={hook.setDescription}
        onDelete={hook.setDescription}
        onSearch={() => hook.attemptSearch()}
        hideSearchIcon={true}
      />
    </div>
  );
}
